/**
 * @Author: AI Assistant
 * @Date: 2025-07-02 15:42:00
 * @Description: 数据字典路由配置
 */

const MenuLayout = () => import('@/components/layout/index.vue')
const AboutConfig = () => import('@/views/about/config.vue')
// 授权管理
const AuthManage = () => import('@/views/authManage/index.vue')
// MCP服务页面
const McpService = () => import('@/views/mcp-service/index.vue')
const McpDetail = () => import('@/views/mcp-service/detail.vue')
// 定制中心
const PcLoginSetting = () => import('@/views/theme-setting/pcLoginStyleSetting.vue')
const ClientEndSetting = () => import('@/views/theme-setting/clientEndStyleSetting.vue')
const ThemeSetting = () => import('@/views/theme-setting/themeSetting.vue')
const ThemeConfig = () => import('@/views/theme-setting/themeConfig.vue')
import dictRoutes from './dict'
const Layout = () => import('@/views/index/index.vue')
export default {
  path: '/manager',
  redirect: '/manager/mcp',
  // 组件
  component: Layout,
  children: [
    {
      path: 'authManage',
      component: MenuLayout,
      children: [
        {
          path: '',
          component: AuthManage,
          meta: {
            name: '授权管理',
            context: 'manager',
            type: 'INNER_APP'
          }
        }
      ]
      // component: () => import('@/views/portal/index.vue')
    },
    {
      path: 'mcp',
      component: MenuLayout,
      children: [
        {
          // 修改: 将 path 从 '/' 改为空字符串 ''
          path: '',
          name: 'McpService',
          component: McpService,
          meta: {
            name: 'MCP服务管理',
            context: 'manager',
            type: 'INNER_APP'
          }
        },
        {
          path: 'detail/:id',
          name: 'McpDetail',
          component: McpDetail,
          meta: {
            name: 'MCP服务详情',
            context: 'manager',
            type: 'INNER_APP'
          }
        }
      ]
      // component: () => import('@/views/portal/index.vue')
    },
    {
      path: 'theme',
      component: MenuLayout,
      children: [
        {
          path: 'pcLogin',
          name: 'PcLogin',
          component: PcLoginSetting,
          meta: {
            name: 'PC登录页设置',
            context: 'manager',
            type: 'INNER_APP'
          }
        },
        {
          path: 'clientEnd',
          name: 'ClientEnd',
          component: ClientEndSetting,
          meta: {
            name: '客户端设置',
            context: 'manager',
            type: 'INNER_APP'

          }
        },
        {
          path: 'setting',
          name: 'Setting',
          component: ThemeSetting,
          meta: {
            name: '系统风格',
            context: 'manager',
            type: 'INNER_APP'
          }
        },
        {
          path: 'config',
          name: 'ThemeConfig',
          component: ThemeConfig,
          meta: {
            name: '主题配置',
            context: 'manager',
            type: 'INNER_APP'
          }
        }
      ]
      // component: () => import('@/views/portal/index.vue')
    },
    {
      path: 'about',
      name: 'about',
      component: MenuLayout,
      children: [
        {
          path: 'config',
          name: 'AboutConfig',
          component: AboutConfig,
          meta: {
            name: '关于页面配置',
            context: 'manager',
            type: 'INNER_APP'
          }
        }
      ]
    },
    ...dictRoutes
  ]
}
